import{debounce as e}from"lodash";var o=function(o){var n=o.fn,d=o.wait,r=o._dependencies,i=(void 0===r?{}:r).debounce,a=void 0===i?e:i;return a(n,d)};export{o as debounce};
